import { Grid } from "@mui/material";
import { useContext, useState } from "react";
import InputPassword from "../../components/generic/inputPassword";
import InputEmail from "../../components/generic/inputEmail";
import BoxTheme from "../../components/generic/box";
import ButtonSubmit from "../../components/generic/buttonSubmit";
import banner from "../../assets/banner.png";
import { AuthContext } from "../../contexts/AuthContext";
import React from "react";
import ForgotPassword from "../../components/generic/forgotPassword";
import ButtonForgotPassword from "../../components/buttonForgotPassword";
import BackgroundLoginSvg from "../../components/generic/backgroundImage/index.js";
import Footer from "../../components/generic/developByFooter";
import NewPassword from "../../components/generic/newPassword";

export default function SignIn() {
  const { signIn } = useContext(AuthContext);
  const [email, setEmail] = useState({
    error: false,
    value: "",
    errorText: "Error",
  });
  const [password, setPassword] = useState({
    error: false,
    value: "",
    errorText: "Error",
  });

  const [control, setControl] = useState({ fase: 0, email: "" });

  const handleLogin = async (event) => {
    event.preventDefault();
    const { email: emailResponse, password: passwordResponse } = await signIn(
      email,
      password
    );
    setEmail(emailResponse);
    setPassword(passwordResponse);
  };

  return (
    <>
      <BackgroundLoginSvg>
        <BoxTheme
          sx={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            width: "100vw",
            justifyContent: "center",
            flexDirection: "column",
            
          }}
        >
          <BoxTheme sx={{ width: "100%",marginTop: "auto", }}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ width: "100%", marginBottom: "96px" }}
            >
              <Grid item xs={10} md={4} sm={10}>
                <img src={banner} style={{ width: "100%" }} alt="banner" />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ width: "100%" }}
            >
              <Grid item xs={10} md={4} sm={10}>
                <BoxTheme
                  component="form"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                  noValidate
                  autoComplete="off"
                  onSubmit={handleLogin}
                >
                  {control.fase == 1 ? (
                    <ForgotPassword handleNext={(email, handleResend) => setControl({ fase: 2, email: email, handleResend })} handleBack={() => setControl({ fase: 0 })}></ForgotPassword>
                  ) : null}
                  {!control.fase ? (
                    <Grid container>
                      <Grid item xs={12}>
                        <InputEmail
                          {...email}
                          required
                          onChange={({ target }) =>
                            setEmail((obj) => {
                              obj.value = target.value;
                              obj.error = false;
                              return { ...obj };
                            })
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ marginTop: "16px" }}>
                        <InputPassword
                          {...password}
                          required
                          onChange={({ target }) =>
                            setPassword((obj) => {
                              obj.value = target.value;
                              obj.error = false;
                              return { ...obj };
                            })
                          }
                        />
                      </Grid>
                      <Grid item sx={{ marginTop: "8px" }}>
                        <ButtonForgotPassword
                          onClick={() => setControl({ fase: 1 })}
                        ></ButtonForgotPassword>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sx={{
                          marginTop: "64px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",

                        }}
                      >
                        <ButtonSubmit children={"Acessar"} />
                      </Grid>
                    </Grid>
                  ) : null}
                  {
                    control.fase == 2 ? (
                      <NewPassword email={control?.email} handleResend={control?.handleResend} handleBack={() => setControl({ fase: 1 })}>
                      </NewPassword>
                    ) : null
                  }
                </BoxTheme>
              </Grid>
            </Grid>
          </BoxTheme>

          <Grid xs={12} sx={{ display: 'flex', justifyContent: 'center', marginTop: "auto", paddingBottom:"50px" }}>
            <Footer>
            </Footer>

          </Grid>
        </BoxTheme>
      </BackgroundLoginSvg>
    </>
  );
}
